import React from 'react';
import { Badge, RRLink } from '@vtblife/uikit';

import { sendAnalyticsEvent } from '../../analytics';

export const VerificationBanner = () => {
    return (
        <RRLink
            href="/partner/company-settings/verification"
            text={false}
            onClick={() =>
                sendAnalyticsEvent({ event: 'lk_action', page_type: 'lk', section: 'menu', type: 'verification' })
            }
        >
            <div>
                <Badge size="s" color="accent">
                    Верифицировать профиль
                </Badge>
            </div>
        </RRLink>
    );
};
